took